import { User } from 'api-clients/identity-server-api-client';
import { kickUser } from 'src/shared/user-functions';
import { HeaderService } from './app/header/header.service';
import { WorkspaceComponentRefService } from './app/workspace/workspace-component-ref.service';
import { environment } from './environments/environment';
import { initializeDDRUM } from './shared/third-party/datadog-rum';
import { initializeFreshchat } from './shared/third-party/freshchat';
import { initializePendo } from './shared/third-party/pendo';
import { UserService } from './shared/user.service';

export function initialize(userService: UserService, workspaceComponentRef: WorkspaceComponentRefService, headerService: HeaderService): () => Promise<User> {
  return async () => {
    let userPromise: Promise<User>;
    try {
      workspaceComponentRef.setWorkspaceComponentRef();

      userPromise = userService.getUser();
      const user = await userPromise;

      if (!user) {
        kickUser();
        return userPromise;
      }

      if (!user.supportPersonId) {
        if (user.products.pendo) {
          initializePendo(user);
        }

        if (environment.datadogClientId) {
          initializeDDRUM(user);
        }
      }

      initializeFreshchat(user, headerService);
      return userPromise;
    } catch {
      kickUser();
      return userPromise;
    }
  };
}
